import { computed, Signal } from '@angular/core';
import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { EntityProps, EntityState } from '@ngrx/signals/entities';
import { remove as removeDiac } from 'diacritics';

import { Aptitude } from '../models/aptitude.model';
import { AptitudeState } from './aptitude.state';
import { SelectedEntityState } from '../../../../shared/store/selected-entity.feature';

type State = EntityState<Aptitude> & AptitudeState & SelectedEntityState;
type Props = EntityProps<Aptitude> & { selectedEntity: Signal<Aptitude | null> };

export function avecSélecteursAptitudes<_>() {
  return signalStoreFeature(
    {
      state: type<State>(),
      props: type<Props>(),
    },
    withComputed(({ filtre, entities }) => ({
      aptitudesFiltrées: computed(() =>
        entities().filter((e) => removeDiac(e.referentiel ?? '').includes(removeDiac(filtre()))),
      ),
    })),
  );
}
